var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / file",
    clipPath: "url(#clip0_301_25134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9375 1H10.875C10.1125 1 9.38123 1.31607 8.84207 1.87868C8.3029 2.44129 8 3.20435 8 4V28C8 28.7956 8.3029 29.5587 8.84207 30.1213C9.38123 30.6839 10.1125 31 10.875 31H28.125C28.8875 31 29.6188 30.6839 30.1579 30.1213C30.6971 29.5587 31 28.7956 31 28V11.5L20.9375 1Z",
    stroke: "#98A2B3",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 1V12H31",
    stroke: "#98A2B3",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 433",
    y: 14,
    width: 24.1307,
    height: 11.8304,
    rx: 2.41307,
    fill: "#A00060"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PPT"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52466 23.049V17.0164H6.68914C7.16157 17.0164 7.55296 17.1018 7.8633 17.2726C8.17364 17.4435 8.4059 17.6772 8.56008 17.9737C8.71427 18.2683 8.79136 18.6001 8.79136 18.9693C8.79136 19.3405 8.71328 19.6743 8.55712 19.9708C8.40294 20.2654 8.16969 20.4991 7.85737 20.6719C7.54703 20.8428 7.15663 20.9282 6.68618 20.9282H5.19772V20.1564H6.60315C6.90164 20.1564 7.14378 20.1054 7.32959 20.0032C7.5154 19.8992 7.65179 19.7578 7.73877 19.5791C7.82574 19.4004 7.86923 19.1971 7.86923 18.9693C7.86923 18.7415 7.82574 18.5393 7.73877 18.3625C7.65179 18.1858 7.51441 18.0473 7.32663 17.9472C7.14082 17.847 6.89571 17.797 6.59129 17.797H5.44086V23.049H4.52466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86544 23.049V17.0164H12.0299C12.5024 17.0164 12.8937 17.1018 13.2041 17.2726C13.5144 17.4435 13.7467 17.6772 13.9009 17.9737C14.0551 18.2683 14.1321 18.6001 14.1321 18.9693C14.1321 19.3405 14.0541 19.6743 13.8979 19.9708C13.7437 20.2654 13.5105 20.4991 13.1982 20.6719C12.8878 20.8428 12.4974 20.9282 12.027 20.9282H10.5385V20.1564H11.9439C12.2424 20.1564 12.4846 20.1054 12.6704 20.0032C12.8562 19.8992 12.9926 19.7578 13.0796 19.5791C13.1665 19.4004 13.21 19.1971 13.21 18.9693C13.21 18.7415 13.1665 18.5393 13.0796 18.3625C12.9926 18.1858 12.8552 18.0473 12.6674 17.9472C12.4816 17.847 12.2365 17.797 11.9321 17.797H10.7816V23.049H9.86544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9068 17.7999V17.0164H19.6064V17.7999H17.7117V23.049H16.7985V17.7999H14.9068Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_25134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.36585238cd0ddb89f473a775a7b7f64c.svg";
export { ForwardRef as ReactComponent };